
const defaultState = {
    info: null,
    loggedIn: false
}

export default function shop (state = defaultState, action) {
    switch (action.type) {
        case "LOGIN":
            return {
                ...state,
                loggedIn: true,
                info: action.payload.info
            }
        case "LOGOUT":
            return {
                ...state,
                info: null,
                loggedIn: false
            }
        default:
            return state;
    }
}